<div class="fixed-bottom card" style="z-index: 10000000;" *ngIf="!(modelService.globalModel.cookiesAccepted.$ | async)">
  <div class="card-body policyWrapper">
    <div class="content pe-1" i18n>By using this website, you agree to our use of cookies. We use cookies to provide you with a great experience and to help our platform run effectively.</div>
    <div class="accept"><button class="primary w-100" (click)="accept()" i18n>Accept</button></div>
    <div class="logout"><button class="primary w-100" *ngIf="!logoutDisabled()" (click)="modelService.globalModel.logout()" i18n>Log out</button></div>
  </div>
</div>
